import "../Tweets.css";

//react
import { useEffect, useState } from "react";

//components
// eslint-disable-next-line no-unused-vars
import TweetGraph from "../../reusable/TweetGraph/TweetGraph";

//antd
// eslint-disable-next-line no-unused-vars
import { Divider, Typography } from "antd";

//hooks
import { useCurrentLanguage } from "../../../hooks/useCurrentLanguage";

//utils
import { getCsvData } from "../../../utils/functions/getCsvData";

//assets
import TEXT from "../../../utils/text/prensa.json";

//functionss
import { formatTrimesterLabel } from "../../../utils/functions/formatTrimesterLabel";

// eslint-disable-next-line no-unused-vars
const { Title } = Typography;

export default function SentimentXeno({
  selectedCountry,
  countryName,
  countries,
  countryOptions,
  //setImg1,
  setImg2,
  //setImg3,
  setImg4,
}) {
  //language
  const { language } = useCurrentLanguage();

  //useState - data xeno
  // eslint-disable-next-line no-unused-vars
  const [data_xeno, setData_xeno] = useState([]);

  //useState - data Gen xeno
  // eslint-disable-next-line no-unused-vars
  const [dataGenXeno, setDataGenXeno] = useState([]);

  //useState - data xeno seguridad
  //const [dataXenoSeg, setDataXenoSeg] = useState([]);

  //useState - img url 1
  // const [imgUrl1, setImgUrl1] = useState("");
  // eslint-disable-next-line no-unused-vars
  const [imgUrl2, setImgUrl2] = useState("");
  // const [imgUrl3, setImgUrl3] = useState("");
  // eslint-disable-next-line no-unused-vars
  const [imgUrl4, setImgUrl4] = useState("");

  // eslint-disable-next-line no-unused-vars
  const isLac = selectedCountry === "LAC";

  //useEffect
  useEffect(() => {
    if (selectedCountry !== "" && countries.length > 0) processDataT(["LAC"]);
    processGenXenoData();
    processDataXenSeg();

    console.log("COUNTRIES IN MIGRATION: ", countryOptions);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCountry, countries]);

  //useEffect - imgs
  useEffect(() => {
    // setImg1(imgUrl1)
    setImg2(imgUrl2);
    // setImg3(imgUrl3)
    setImg4(imgUrl4);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [imgUrl2, imgUrl4]);

  const processDataT = async (selectedCountries) => {
    let df = await getCsvData(`/data/sentiment/xenofobo_3m.csv`);
    let df1 = [...df];
    let df_lac = [...df];
    let df_countries = [...df];

    //filter country
    if (selectedCountry !== "LAC") {
      df1 = df1.filter((row) => row.country === selectedCountry);
    }

    //filter LAC
    let tempDf1 = {};
    df_lac.forEach((e) => {
      let date = formatTrimesterLabel(e.date);
      if (!tempDf1[date]) {
        tempDf1[date] = {
          date: e.date,
          positive: 0,
          negative: 0,
          Xenofobo: 0,
          count: 0,
        };
      }
      tempDf1[date].positive += parseFloat(e.positive) || 0;
      tempDf1[date].negative += parseFloat(e.negative) || 0;
      tempDf1[date].Xenofobo += parseFloat(e.Xenofobo) || 0;
      tempDf1[date].count++;
    });
    df_lac = Object.values(tempDf1).map((entry) => ({
      date: entry.date,
      positive: entry.positive / entry.count,
      negative: entry.negative / entry.count,
      Xenofobo: entry.Xenofobo / entry.count,
    }));

    let dates = [];
    let values = [];
    let values2 = [];
    let values3 = [];
    let values3_lac = [];
    let values3_country1 = [];
    let values3_country2 = [];
    let values3_country3 = [];

    if (selectedCountry === "LAC") {
      df1 = df_lac;

      //filter countries
      let df_country1 =
        selectedCountries.length >= 2
          ? [...df_countries].filter(
              (row) => row.country === selectedCountries[1]
            ) || []
          : [];
      let df_country2 =
        selectedCountries.length >= 3
          ? [...df_countries].filter(
              (row) => row.country === selectedCountries[2]
            ) || []
          : [];
      let df_country3 =
        selectedCountries.length >= 4
          ? [...df_countries].filter(
              (row) => row.country === selectedCountries[3]
            ) || []
          : [];

      df_country1.forEach((e) => {
        values3_country1.push(parseFloat(e.Xenofobo));
      });
      df_country2.forEach((e) => {
        values3_country2.push(parseFloat(e.Xenofobo));
      });
      df_country3.forEach((e) => {
        values3_country3.push(parseFloat(e.Xenofobo));
      });
    }

    df1.forEach((e) => {
      dates.push(formatTrimesterLabel(e.date, language));
      values.push(parseFloat(e.positive));
      values2.push(parseFloat(e.negative));
      values3.push(parseFloat(e.Xenofobo));
    });

    if (selectedCountry !== "LAC") {
      df_lac.forEach((e) => {
        values3_lac.push(parseFloat(e.Xenofobo));
      });
    }

    let combinedArray = [];

    if (selectedCountry !== "LAC") {
      combinedArray = [dates, values3, values3_lac];
    } else {
      combinedArray = [dates, values3];
      //push countries if length > 0
      if (selectedCountries.length >= 2) combinedArray.push(values3_country1);
      if (selectedCountries.length >= 3) combinedArray.push(values3_country2);
      if (selectedCountries.length >= 4) combinedArray.push(values3_country3);
    }

    let seriesName = [];
    let lac = language === "es" ? "ALC" : "LAC";
    if (selectedCountry !== "LAC") {
      seriesName = [countryName, lac];
    } else {
      seriesName = [lac];

      if (selectedCountries.length >= 2) {
        let tempCountry1 = countryOptions.find(
          (e) => e.code === selectedCountries[1]
        );
        console.log("tempCountry1: ", tempCountry1);
        seriesName.push(
          language === "es"
            ? tempCountry1.country_text
            : tempCountry1.country_text_en
        );
      }
      if (selectedCountries.length >= 3) {
        let tempCountry2 = countryOptions.find(
          (e) => e.code === selectedCountries[2]
        );
        seriesName.push(
          language === "es"
            ? tempCountry2.country_text
            : tempCountry2.country_text_en
        );
      }
      if (selectedCountries.length >= 4) {
        let tempCountry3 = countryOptions.find(
          (e) => e.code === selectedCountries[3]
        );
        seriesName.push(
          language === "es"
            ? tempCountry3.country_text
            : tempCountry3.country_text_en
        );
      }
    }

    const series = [
      seriesName,
      combinedArray[0],
      combinedArray.reduce((acc, val, index) => {
        if (index !== 0) acc.push(val);
        return acc;
      }, []),
    ];

    let temp2 = [
      {
        id: "q1",
        data: series,
        rotate: false,
        graphType: "g_v_bar",
        hasOptions: false,
        isPercentage: true,
        seriesName: seriesName,
        updateTotrimester: false,
        hasCountries: selectedCountry === "LAC" ? true : false,
        countryOptions: countries,
        useColors: false,
        selectedCountries: selectedCountries,
        description: TEXT["indicadores"]["xeno1"][language],
      },
    ];

    setData_xeno(temp2);
  };

  const processGenXenoData = async () => {
    let df1 = await getCsvData(`/data/discussion/xeno_topics_top3_3m.csv`);

    //filter country
    if (selectedCountry !== "LAC") {
      df1 = df1.filter((row) => row.country === selectedCountry);

      //sort by date
      df1.sort((a, b) => new Date(a.date) - new Date(b.date));
    } else {
      let tempDf1 = {};
      df1.forEach((e) => {
        let date = formatTrimesterLabel(e.date);
        if (!tempDf1[date]) {
          tempDf1[date] = {
            date: e.date,
            seguridad: 0,
            servicios: 0,
            empleo: 0,
            politicas: 0,
            transito: 0,
            count: 0,
          };
        }
        tempDf1[date].seguridad += parseFloat(e.seguridad) || 0;
        tempDf1[date].servicios += parseFloat(e.servicios) || 0;
        tempDf1[date].empleo += parseFloat(e.empleo) || 0;
        tempDf1[date].politicas += parseFloat(e.politicas) || 0;
        tempDf1[date].transito += parseFloat(e.transito) || 0;
        tempDf1[date].count++;
      });

      df1 = Object.values(tempDf1).map((entry) => ({
        date: entry.date,
        seguridad: entry.seguridad / entry.count,
        servicios: entry.servicios / entry.count,
        empleo: entry.empleo / entry.count,
        politicas: entry.politicas / entry.count,
        transito: entry.transito / entry.count,
      }));
    }

    let dates = [];
    let values = [];
    let values2 = [];
    let values3 = [];
    let values4 = [];
    let values5 = [];

    df1.forEach((e) => {
      dates.push(formatTrimesterLabel(e.date));
      values.push(parseFloat(e.seguridad));
      values2.push(parseFloat(e.servicios));
      values3.push(parseFloat(e.empleo));
      values4.push(parseFloat(e.politicas));
      values5.push(parseFloat(e.transito));
    });

    //let combinedArray = [dates, values, values2, values3, values4, values5];

    /*let temp = [
      {
        id: "q1",
        data: combinedArray,
        rotate: false,
        graphType: "line",
        hasOptions: false,
        isPercentage: true,
        seriesName:
          language === "es"
            ? ["Seguridad", "Servicios", "Empleo", "Políticas", "Tránsito"]
            : ["Security", "Services", "Employment", "Policies", "Transit"],
        updateTotrimester: false,
        useColors: false,
        description: TEXT["indicadores"]["xeno1"][language],
      },
    ];*/
    // commenting to hide
    //setDataGenXeno(temp)
    setDataGenXeno([]);
  };

  const processDataXenSeg = async () => {
    let df1 = await getCsvData(`/data/sentiment/xeno_seguridad.csv`);

    //filter country
    if (selectedCountry !== "LAC") {
      df1 = df1.filter((row) => row.country === selectedCountry);
    } else {
      let tempDf1 = {};
      df1.forEach((e) => {
        let date = formatTrimesterLabel(e.date);
        if (!tempDf1[date]) {
          tempDf1[date] = {
            date: e.date,
            seguridad_xeno: 0,
            count: 0,
          };
        }
        tempDf1[date].seguridad_xeno += parseFloat(e.seguridad_xeno) || 0;
        tempDf1[date].count++;
      });

      df1 = Object.values(tempDf1).map((entry) => ({
        date: entry.date,
        seguridad_xeno: entry.seguridad_xeno / entry.count,
      }));
    }

    let dates = [];
    let values = [];

    df1.forEach((e) => {
      dates.push(formatTrimesterLabel(e.date));
      values.push(parseFloat(e.seguridad_xeno));
    });

    /*let combinedArray2 = [dates, values];*/

    /*let temp = [
      {
        id: "q1",
        data: combinedArray2,
        rotate: false,
        graphType: "line",
        hasOptions: false,
        isPercentage: true,
        seriesName:
          language === "es" ? ["Seguridad Xeno"] : ["Xenophobia Security"],
        updateTotrimester: false,
        useColors: false,
        description: TEXT["indicadores"]["xeno1"][language],
      },
    ];*/

    //setDataXenoSeg(temp);
  };

  //handle countries change
  // eslint-disable-next-line no-unused-vars
  const handleCountriesChange = (countries) => {
    console.log("countries: ", countries);
    processDataT(countries);
  };

  return (null);
  /*return (
    <>
      <div className="surveys-page-content prensa-small-section-container">
        <div className="surveys-page-graphs">
          <div className="survey-page-full-surveys">
            <div className="full-screen">
              <div className="prensa-chart-info-large-container">
                <div className="data-page-section-title text-left prensa-chart-title">
                  {TEXT["sentiment"]["xenophobia"]["title_sec"][language]}
                </div>
                {isLac && (
                  <>
                    <Title
                      level={2}
                      style={{
                        color: "var(--blue-primary)",
                        textAlign: "left",
                      }}
                    >
                      {TEXT["sentiment"]["xenophobia"]["title"][language]}
                    </Title>
                    <div className="prensa-text-container">
                      <p>
                        {
                          TEXT["sentiment"]["xenophobia"]["description"][
                            language
                          ]
                        }
                      </p>
                    </div>
                  </>
                )}
              </div>
              <div>
                {data_xeno.length > 0 && (
                  <TweetGraph
                    data={data_xeno}
                    title={
                      TEXT["sentiment"]["xenophobia"]["title_graph"][language] +
                      " " +
                      countryName
                    }
                    onCountriesChange={handleCountriesChange}
                    setImgUrl={setImgUrl2}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Divider className="divider-full-screen" />

      <div
        className={`surveys-page-content ${
          !isLac ? "prensa-small-section-container" : ""
        }`}
      >
        <div className="surveys-page-graphs">
          <div className="survey-page-full-surveys">
            <div
              className={`full-screen ${
                isLac ? "prensa-chart-container sm:!gap-20" : ""
              }`}
            >
              <div>
                {dataGenXeno.length > 0 && (
                  <TweetGraph
                    data={dataGenXeno}
                    title={
                      TEXT["sentiment"]["xenophobia"]["analysis"][language] +
                      countryName
                    }
                    setImgUrl={setImgUrl4}
                  />
                )}
              </div>
              <div className="prensa-chart-info-container pt-8">
                {isLac && (
                  <>
                    <Title
                      level={2}
                      style={{
                        color: "var(--blue-primary)",
                        textAlign: "left",
                      }}
                    >
                      {
                        TEXT["sentiment"]["xenophobia"]["analysis"]["title"][
                          language
                        ]
                      }
                    </Title>
                    <div className="prensa-text-container">
                      <p>
                        {
                          TEXT["sentiment"]["xenophobia"]["analysis"][
                            "description"
                          ][language]
                        }
                      </p>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );*/
}
